/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLast_comment = {
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_comment" | "ReplyListContainerLastFlattened_comment">;
    readonly " $refType": "ReplyListContainerLast_comment";
};
export type ReplyListContainerLast_comment$data = ReplyListContainerLast_comment;
export type ReplyListContainerLast_comment$key = {
    readonly " $data"?: ReplyListContainerLast_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLast_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "flattenReplies"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLast_comment",
    "selections": [
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LocalReplyListContainer_comment"
                }
            ]
        },
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReplyListContainerLastFlattened_comment"
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '06baee84a322a7250927b30ad76f6bf8';
export default node;
